import { UserPlus } from "react-feather";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";

interface InviteAffiliateButtonProps {
  onClick: () => void;
  variant?: "primary" | "secondary";
  className?: string;
}

export function InviteAffiliateButton({
  onClick,
  variant = "primary",
  className = "",
}: InviteAffiliateButtonProps) {
  return (
    <Button
      type="button"
      onClick={onClick}
      variant={variant === "primary" ? "default" : "outline"}
      className={cn("min-h-[40px] min-w-fit flex-shrink-0", className)}
    >
      <UserPlus className="h-4 w-4" />
      <span className="hidden sm:inline">Invite affiliates</span>
      <span className="sm:hidden">Invite</span>
    </Button>
  );
}
